/**
 * @generated SignedSource<<30e7c032e4037ea1655d3ed2f9cf6863>>
 * @relayHash 7e7b1b03754c89e3156b5d265f8fc3a5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/579.0.0-2026-09-30T18:54:05.208Z/pdpRespMarketplacePrimaryRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type pdpRespMarketplacePrimaryRootQuery$variables = {
  afterDisplay?: boolean | null;
  afterDisplayOrBtSsr?: boolean | null;
  fetchPdp?: boolean | null;
  fetchUser?: boolean | null;
  forcedCurrency?: Currency | null;
  isEstimateSimilarSoldVariant?: boolean | null;
  isInteractivePdpChat?: boolean | null;
  isMultiSku?: boolean | null;
  isPdpItemModuleTestVariant?: boolean | null;
  isPdpSellerModuleTestVariant?: boolean | null;
  isPdpSimilarSoldItemsModuleVariant?: boolean | null;
  isTrade?: boolean | null;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  personalizationId?: string | null;
  priceBookName?: string | null;
  similarItemsCount: number;
  userCountryCode?: string | null;
  userId?: string | null;
  userIds: ReadonlyArray<string | null>;
  userZipCode?: string | null;
};
export type pdpRespMarketplacePrimaryRootQuery$data = {
  readonly viewer: {
    readonly itemRead: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_item" | "findPdpItemReadError_itemRead" | "handlePdpStatuses_item">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_viewer" | "PdpRespMarketplaceLayoutPrimary_viewer">;
  };
};
export type pdpRespMarketplacePrimaryRootQuery = {
  response: pdpRespMarketplacePrimaryRootQuery$data;
  variables: pdpRespMarketplacePrimaryRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplay"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplayOrBtSsr"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchPdp"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forcedCurrency"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isEstimateSimilarSoldVariant"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isInteractivePdpChat"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isMultiSku"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPdpItemModuleTestVariant"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPdpSellerModuleTestVariant"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPdpSimilarSoldItemsModuleVariant"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemIds"
},
v14 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v15 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "similarItemsCount"
},
v17 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v18 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v20 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v21 = {
  "alias": "isPdpUrlTranslationEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "translatedPdpUrls"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
},
v22 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "microdata",
  "storageKey": null
},
v24 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v25 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v26 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "currency",
      "variableName": "forcedCurrency"
    },
    (v24/*:: as any*/),
    (v25/*:: as any*/)
  ],
  "kind": "ScalarField",
  "name": "microdataOffers",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpURL",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ogTitle",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceAmount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceCurrency",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "LanguageAnnotations",
  "kind": "LinkedField",
  "name": "languageAnnotations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hrefLang",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webPath",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v38 = [
  (v37/*:: as any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    (v36/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageVersionType",
      "kind": "LinkedField",
      "name": "type",
      "plural": false,
      "selections": (v38/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPriceUponRequest",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingListed",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingNotListed",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingUnlisted",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingMigrated",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNew",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWip",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSold",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternal",
  "storageKey": null
},
v54 = [
  {
    "kind": "Literal",
    "name": "metricTypes",
    "value": [
      "ITEM_LISTING_VIEWS"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeRange",
    "value": "LAST_6_MONTHS"
  }
],
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v56 = [
  (v55/*:: as any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivateVisibilityType",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrivateListing",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirectType",
  "kind": "LinkedField",
  "name": "redirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageType",
      "storageKey": null
    }
  ],
  "type": "ItemReadError",
  "abstractKey": null
},
v62 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v63 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v64 = [
  (v62/*:: as any*/),
  (v63/*:: as any*/)
],
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v67 = [
  (v65/*:: as any*/),
  (v66/*:: as any*/)
],
v68 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v69 = [
  (v68/*:: as any*/)
],
v70 = {
  "alias": "monthsSinceStartDate",
  "args": [
    {
      "kind": "Literal",
      "name": "unit",
      "value": "MONTH"
    }
  ],
  "kind": "ScalarField",
  "name": "timeSinceStartDate",
  "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
},
v71 = [
  {
    "kind": "Literal",
    "name": "photoType",
    "value": "DEALER_STOREFRONT_HEADSHOT"
  }
],
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v74 = [
  (v72/*:: as any*/),
  (v73/*:: as any*/),
  (v66/*:: as any*/)
],
v75 = {
  "alias": null,
  "args": (v71/*:: as any*/),
  "concreteType": "Photo",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": (v74/*:: as any*/),
  "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "StorefrontProfile",
  "kind": "LinkedField",
  "name": "liveStorefrontProfile",
  "plural": false,
  "selections": [
    (v75/*:: as any*/),
    (v66/*:: as any*/)
  ],
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerProfile",
  "kind": "LinkedField",
  "name": "sellerProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerOrderFeedbackPdpQueryConnection",
  "kind": "LinkedField",
  "name": "orderFeedbackPdp",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackType",
          "kind": "LinkedField",
          "name": "aggregatedFeedback",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackQuestionType",
              "kind": "LinkedField",
              "name": "overallExperience",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mean",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicNoteTotalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDistinguished",
  "storageKey": null
},
v80 = {
  "alias": "isRewardsTier2",
  "args": [
    {
      "kind": "Literal",
      "name": "listName",
      "value": "SELLER_REWARDS_2"
    }
  ],
  "kind": "ScalarField",
  "name": "isAnchorListMember",
  "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGoldTier",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPlatinumTier",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerTierDataNotFound",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerTiers",
  "kind": "LinkedField",
  "name": "sellerTiers",
  "plural": false,
  "selections": [
    (v81/*:: as any*/),
    (v82/*:: as any*/),
    (v83/*:: as any*/)
  ],
  "storageKey": null
},
v85 = [
  (v63/*:: as any*/)
],
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v88 = [
  (v68/*:: as any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
],
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAcceptOffer",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPurchase",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMakeOffer",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showRequestPrice",
  "storageKey": null
},
v93 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v94 = {
  "alias": null,
  "args": (v93/*:: as any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v102 = {
  "kind": "Literal",
  "name": "includePlayButton",
  "value": false
},
v103 = {
  "kind": "Literal",
  "name": "pad",
  "value": false
},
v104 = {
  "kind": "Literal",
  "name": "size",
  "value": "w1280h720"
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v107 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "adaptive"
  }
],
v108 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "link",
    "storageKey": null
  }
],
v109 = {
  "kind": "Literal",
  "name": "height",
  "value": 720
},
v110 = {
  "kind": "Literal",
  "name": "width",
  "value": 1280
},
v111 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v112 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v55/*:: as any*/)
],
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v114 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v115 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v116 = [
  (v68/*:: as any*/),
  {
    "kind": "Literal",
    "name": "canShowOnHoldForDifferentBuyer",
    "value": false
  },
  (v114/*:: as any*/),
  (v115/*:: as any*/),
  (v24/*:: as any*/),
  (v25/*:: as any*/)
],
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v119 = [
  (v117/*:: as any*/),
  (v118/*:: as any*/)
],
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v119/*:: as any*/),
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVatIncluded",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": (v116/*:: as any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v119/*:: as any*/),
      "storageKey": null
    },
    (v120/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "privateOfferConvertedAmountList",
      "plural": true,
      "selections": (v119/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privateOfferPercentageOff",
      "storageKey": null
    },
    (v121/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerExpirationDate",
      "storageKey": null
    },
    (v122/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPath",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnlimitedQuantity",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v129 = {
  "alias": "priceType",
  "args": [
    {
      "kind": "Literal",
      "name": "buyerId",
      "value": ""
    },
    (v114/*:: as any*/),
    {
      "kind": "Literal",
      "name": "isTrade",
      "value": false
    }
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v121/*:: as any*/)
  ],
  "storageKey": "displayPrice(buyerId:\"\",catchNonFatalErrors:false,isTrade:false)"
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "USD",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v132 = [
  (v120/*:: as any*/),
  (v122/*:: as any*/)
],
v133 = [
  (v68/*:: as any*/),
  {
    "kind": "Literal",
    "name": "isBuyerEstimateEnabled",
    "value": true
  },
  (v115/*:: as any*/),
  (v24/*:: as any*/),
  (v25/*:: as any*/)
],
v134 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v118/*:: as any*/),
    (v117/*:: as any*/)
  ],
  "storageKey": null
},
v135 = [
  (v134/*:: as any*/)
],
v136 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": (v135/*:: as any*/),
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "minAmount",
  "plural": false,
  "selections": (v135/*:: as any*/),
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "maxAmount",
  "plural": false,
  "selections": (v135/*:: as any*/),
  "storageKey": null
},
v139 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v133/*:: as any*/),
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        (v136/*:: as any*/),
        (v137/*:: as any*/),
        (v138/*:: as any*/)
      ],
      "storageKey": null
    }
  ]
},
v140 = {
  "alias": null,
  "args": [
    (v25/*:: as any*/),
    (v63/*:: as any*/),
    {
      "kind": "Variable",
      "name": "userZipCode",
      "variableName": "userZipCode"
    }
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v141 = [
  {
    "kind": "Literal",
    "name": "shortTitles",
    "value": true
  }
],
v142 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabType",
  "storageKey": null
},
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabTitle",
  "storageKey": null
},
v144 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentHeader",
  "storageKey": null
},
v145 = [
  (v73/*:: as any*/),
  (v99/*:: as any*/)
],
v146 = {
  "alias": null,
  "args": null,
  "concreteType": "StoryTellingModuleCreator",
  "kind": "LinkedField",
  "name": "contentCreatorAttribution",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creatorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "creatorBrowseUrl",
      "plural": false,
      "selections": (v145/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v147 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentBodyText",
  "storageKey": null
},
v148 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainImage",
  "storageKey": null
},
v149 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainVideo",
  "storageKey": null
},
v150 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "browseLink",
  "plural": false,
  "selections": (v145/*:: as any*/),
  "storageKey": null
},
v151 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallImage",
  "storageKey": null
},
v152 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCustomizable",
  "storageKey": null
},
v153 = [
  (v42/*:: as any*/),
  (v66/*:: as any*/)
],
v154 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v153/*:: as any*/),
  "storageKey": null
},
v155 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "customizable",
  "plural": true,
  "selections": [
    (v154/*:: as any*/),
    (v98/*:: as any*/)
  ],
  "storageKey": null
},
v156 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "ringResizable",
  "plural": true,
  "selections": [
    (v154/*:: as any*/)
  ],
  "storageKey": null
},
v157 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "leadTime",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        (v66/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v158 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemAttributes",
  "kind": "LinkedField",
  "name": "attributes",
  "plural": false,
  "selections": [
    (v155/*:: as any*/),
    (v156/*:: as any*/),
    (v157/*:: as any*/)
  ],
  "storageKey": null
},
v159 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seoDescription",
  "storageKey": null
},
v160 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v161 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delimiter",
  "storageKey": null
},
v162 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailDisplayName",
  "storageKey": null
},
v163 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPdpDetailValueInterface"
},
v164 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDetails",
  "storageKey": null
},
v165 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        (v120/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PdpDetailVersionsValue",
  "abstractKey": null
},
v166 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RingSizeDetail",
      "kind": "LinkedField",
      "name": "ringSizes",
      "plural": true,
      "selections": (v112/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "PdpDetailRingSize",
  "abstractKey": null
},
v167 = {
  "alias": null,
  "args": null,
  "concreteType": "PdpDetail",
  "kind": "LinkedField",
  "name": "pdpDetailsDisplay",
  "plural": true,
  "selections": [
    (v160/*:: as any*/),
    (v161/*:: as any*/),
    (v162/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "detailValues",
      "plural": true,
      "selections": [
        (v60/*:: as any*/),
        (v163/*:: as any*/),
        (v160/*:: as any*/),
        (v51/*:: as any*/),
        (v97/*:: as any*/),
        (v164/*:: as any*/),
        (v95/*:: as any*/),
        (v165/*:: as any*/),
        (v166/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v168 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAvailable",
  "storageKey": null
},
v169 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasShipmentQuotes",
  "storageKey": null
},
v170 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
],
v171 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        (v25/*:: as any*/)
      ],
      "concreteType": "InlineCtaCopy",
      "kind": "LinkedField",
      "name": "returnPolicySection",
      "plural": false,
      "selections": (v170/*:: as any*/),
      "storageKey": null
    }
  ]
},
v172 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "customizableDetailReturnCopy",
  "plural": false,
  "selections": (v170/*:: as any*/),
  "storageKey": null
},
v173 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "returnPolicySectionHeader",
  "plural": false,
  "selections": (v170/*:: as any*/),
  "storageKey": null
},
v174 = {
  "alias": null,
  "args": (v85/*:: as any*/),
  "concreteType": "ReturnPolicy",
  "kind": "LinkedField",
  "name": "returnPolicy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accept",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReturnPolicyCopy",
      "kind": "LinkedField",
      "name": "buyerCopy",
      "plural": false,
      "selections": [
        (v171/*:: as any*/),
        (v172/*:: as any*/),
        (v173/*:: as any*/)
      ],
      "storageKey": null
    },
    (v66/*:: as any*/)
  ],
  "storageKey": null
},
v175 = [
  {
    "kind": "Literal",
    "name": "fullCountryName",
    "value": true
  }
],
v176 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": "itemAddress",
      "args": (v175/*:: as any*/),
      "kind": "ScalarField",
      "name": "displayCityStateCountry",
      "storageKey": "displayCityStateCountry(fullCountryName:true)"
    },
    (v66/*:: as any*/)
  ],
  "storageKey": null
},
v177 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnpurchasable",
  "storageKey": null
},
v178 = [
  (v68/*:: as any*/),
  (v115/*:: as any*/),
  (v24/*:: as any*/),
  (v25/*:: as any*/)
],
v179 = {
  "alias": "recommendedPrice",
  "args": (v178/*:: as any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    (v136/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "medianAmount",
      "plural": false,
      "selections": (v135/*:: as any*/),
      "storageKey": null
    },
    (v137/*:: as any*/),
    (v138/*:: as any*/)
  ],
  "storageKey": null
},
v180 = [
  (v118/*:: as any*/),
  (v134/*:: as any*/)
],
v181 = {
  "alias": null,
  "args": (v133/*:: as any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": (v180/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "minAmount",
      "plural": false,
      "selections": (v180/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "maxAmount",
      "plural": false,
      "selections": (v180/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v182 = {
  "alias": null,
  "args": (v85/*:: as any*/),
  "concreteType": "ReturnPolicy",
  "kind": "LinkedField",
  "name": "returnPolicy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeEuReturns",
          "value": true
        },
        (v25/*:: as any*/)
      ],
      "kind": "ScalarField",
      "name": "returnDays",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v183 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "recommendedPrice",
      "args": (v178/*:: as any*/),
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        (v128/*:: as any*/)
      ],
      "storageKey": null
    },
    (v181/*:: as any*/),
    (v182/*:: as any*/)
  ]
},
v184 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v185 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "itemThumbnail",
          "args": (v184/*:: as any*/),
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"thumb\")"
        }
      ]
    }
  ]
},
v186 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v69/*:: as any*/),
      "kind": "ScalarField",
      "name": "hasActiveHoldForBuyer",
      "storageKey": null
    }
  ]
},
v187 = [
  (v37/*:: as any*/),
  (v66/*:: as any*/)
],
v188 = {
  "alias": "photoUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "master"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"master\")"
},
v189 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "measurementUnit",
  "storageKey": null
},
v190 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurementsList",
      "plural": true,
      "selections": [
        (v189/*:: as any*/),
        (v106/*:: as any*/),
        (v105/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diameter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryHeight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v191 = {
  "condition": "isPdpSimilarSoldItemsModuleVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "categoryL3",
          "args": [
            {
              "kind": "Literal",
              "name": "level",
              "value": 3
            }
          ],
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "getCategoriesByLevel",
          "plural": true,
          "selections": (v187/*:: as any*/),
          "storageKey": "getCategoriesByLevel(level:3)"
        },
        (v188/*:: as any*/),
        (v190/*:: as any*/)
      ]
    }
  ]
},
v192 = {
  "kind": "InlineFragment",
  "selections": [
    (v66/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v193 = {
  "kind": "Literal",
  "name": "feedbackSellerPublicNoteHasText",
  "value": true
},
v194 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v195 = {
  "kind": "Literal",
  "name": "minimumReviewRating",
  "value": 4
},
v196 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerOrderQuantity",
  "storageKey": null
},
v197 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v198 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v197/*:: as any*/)
  ],
  "storageKey": null
},
v199 = {
  "alias": null,
  "args": (v184/*:: as any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v200 = {
  "alias": null,
  "args": null,
  "concreteType": "MCAnalytics",
  "kind": "LinkedField",
  "name": "analytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalyticsMetrics",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCMetricResponseTime",
          "kind": "LinkedField",
          "name": "responseTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summaryCopy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v201 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      (v91/*:: as any*/)
    ],
    "storageKey": null
  }
],
v202 = {
  "alias": null,
  "args": (v69/*:: as any*/),
  "kind": "ScalarField",
  "name": "hasRequestedHoldForBuyer",
  "storageKey": null
},
v203 = {
  "alias": null,
  "args": (v88/*:: as any*/),
  "concreteType": "ItemDisplayInfo",
  "kind": "LinkedField",
  "name": "displayInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHoldRequest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v204 = {
  "condition": "isPdpSellerModuleTestVariant",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v80/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "kind": "LinkedField",
          "name": "liveStorefrontProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aboutUsUnbranded",
              "storageKey": null
            },
            (v66/*:: as any*/),
            {
              "alias": "headshots",
              "args": (v71/*:: as any*/),
              "concreteType": "Photo",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": (v74/*:: as any*/),
              "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaAlbum",
              "kind": "LinkedField",
              "name": "galleryAlbum",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MediaElement",
                  "kind": "LinkedField",
                  "name": "mediaList",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "element",
                      "plural": false,
                      "selections": [
                        (v60/*:: as any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v73/*:: as any*/)
                          ],
                          "type": "Photo",
                          "abstractKey": null
                        },
                        (v192/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v66/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v66/*:: as any*/)
              ],
              "storageKey": null
            },
            (v75/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "establishmentYear",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v78/*:: as any*/),
        (v70/*:: as any*/),
        (v77/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "shippingAddress",
          "plural": false,
          "selections": [
            {
              "alias": "displayFullCityStateCountry",
              "args": (v175/*:: as any*/),
              "kind": "ScalarField",
              "name": "displayCityStateCountry",
              "storageKey": "displayCityStateCountry(fullCountryName:true)"
            },
            (v66/*:: as any*/)
          ],
          "storageKey": null
        },
        (v84/*:: as any*/),
        {
          "alias": "dealerDetailsHeaderFeedback",
          "args": [
            (v193/*:: as any*/),
            (v194/*:: as any*/),
            (v195/*:: as any*/)
          ],
          "concreteType": "SellerOrderFeedbackPdpQueryConnection",
          "kind": "LinkedField",
          "name": "orderFeedbackPdp",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SellerOrderFeedbackPdpQueryEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v60/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4)"
        },
        (v79/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agreementStart",
          "storageKey": null
        },
        (v196/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MCAnalytics",
          "kind": "LinkedField",
          "name": "analytics",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MCAnalyticsMetrics",
              "kind": "LinkedField",
              "name": "metrics",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MCMetricResponseTime",
                  "kind": "LinkedField",
                  "name": "responseTime",
                  "plural": false,
                  "selections": (v56/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeAssociation",
          "kind": "LinkedField",
          "name": "tradeAssociations",
          "plural": true,
          "selections": [
            (v42/*:: as any*/),
            (v97/*:: as any*/),
            (v66/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "dealerDetailsOrderFeedbackPdp",
              "args": [
                (v193/*:: as any*/),
                (v194/*:: as any*/),
                (v195/*:: as any*/),
                {
                  "kind": "Literal",
                  "name": "sortBy",
                  "value": "sellerExperienceDesc"
                }
              ],
              "concreteType": "SellerOrderFeedbackPdpQueryConnection",
              "kind": "LinkedField",
              "name": "orderFeedbackPdp",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderFeedbackPdp",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "completedDate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Transaction",
                          "kind": "LinkedField",
                          "name": "transaction",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "User",
                              "kind": "LinkedField",
                              "name": "buyer",
                              "plural": false,
                              "selections": [
                                (v198/*:: as any*/),
                                (v66/*:: as any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Shipment",
                              "kind": "LinkedField",
                              "name": "shipment",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Address",
                                  "kind": "LinkedField",
                                  "name": "shippingAddress",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "displayState",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "displayCountry",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "country",
                                      "storageKey": null
                                    },
                                    (v66/*:: as any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v66/*:: as any*/)
                              ],
                              "storageKey": null
                            },
                            (v66/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "overallExperience",
                          "plural": false,
                          "selections": [
                            (v60/*:: as any*/),
                            (v86/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "publicNote",
                          "plural": false,
                          "selections": [
                            (v60/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "freetext",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Item",
                          "kind": "LinkedField",
                          "name": "item",
                          "plural": false,
                          "selections": [
                            (v30/*:: as any*/),
                            (v199/*:: as any*/),
                            (v66/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        (v66/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Phone",
              "kind": "LinkedField",
              "name": "trackedPhone",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phoneNumber",
                  "storageKey": null
                },
                (v66/*:: as any*/)
              ],
              "storageKey": null
            },
            (v200/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": "dealerDetailsDisplayInfo",
          "args": null,
          "concreteType": "ItemDisplayInfo",
          "kind": "LinkedField",
          "name": "displayInfo",
          "plural": false,
          "selections": (v201/*:: as any*/),
          "storageKey": null
        },
        {
          "condition": "fetchUser",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            (v202/*:: as any*/),
            (v203/*:: as any*/)
          ]
        }
      ]
    }
  ]
},
v205 = [
  (v118/*:: as any*/),
  (v117/*:: as any*/),
  (v120/*:: as any*/)
],
v206 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  },
  (v62/*:: as any*/),
  {
    "kind": "Literal",
    "name": "requestSourceRole",
    "value": "BUYER"
  }
],
v207 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v208 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v209 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleItemSoldPrice",
  "storageKey": null
},
v210 = {
  "alias": null,
  "args": (v206/*:: as any*/),
  "concreteType": "SimilarSoldItemsConnectionConnection",
  "kind": "LinkedField",
  "name": "similarSoldItemsConnection",
  "plural": false,
  "selections": [
    (v208/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SimilarSoldItemsConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SimilarSoldItemsNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v207/*:: as any*/),
            (v209/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v51/*:: as any*/),
                (v124/*:: as any*/),
                (v113/*:: as any*/),
                (v66/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v211 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "countryCode",
      "variableName": "userCountryCode"
    }
  ],
  "kind": "ScalarField",
  "name": "isGdprApplicable",
  "storageKey": null
},
v212 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingOptInMessage",
  "storageKey": null
},
v213 = {
  "alias": "suppressNewSellerSignals",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "suppressNewSellerSignals"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
},
v214 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "similarSoldItemsResults",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 0
        },
        (v62/*:: as any*/)
      ],
      "concreteType": "SimilarSoldItemsConnection",
      "kind": "LinkedField",
      "name": "similarSoldItems",
      "plural": false,
      "selections": [
        (v208/*:: as any*/)
      ],
      "storageKey": null
    }
  ]
},
v215 = [
  {
    "condition": "isPdpSimilarSoldItemsModuleVariant",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "condition": "afterDisplay",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v206/*:: as any*/),
            "concreteType": "SimilarSoldItemsConnectionConnection",
            "kind": "LinkedField",
            "name": "similarSoldItemsConnection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SimilarSoldItemsConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SimilarSoldItemsNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v207/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "soldDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          (v42/*:: as any*/),
                          (v30/*:: as any*/),
                          (v100/*:: as any*/),
                          (v188/*:: as any*/),
                          (v28/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v116/*:: as any*/),
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": (v135/*:: as any*/),
                            "storageKey": null
                          },
                          (v190/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PdpDetail",
                            "kind": "LinkedField",
                            "name": "pdpDetailsDisplay",
                            "plural": true,
                            "selections": [
                              (v160/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "detailValues",
                                "plural": true,
                                "selections": [
                                  (v60/*:: as any*/),
                                  (v97/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v206/*:: as any*/),
                "concreteType": "SimilarSoldItemsConnectionConnection",
                "kind": "LinkedField",
                "name": "similarSoldItemsConnection",
                "plural": false,
                "selections": [
                  (v208/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SimilarSoldItemsConnectionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimilarSoldItemsNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v209/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v51/*:: as any*/),
                              (v124/*:: as any*/),
                              (v113/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "condition": "afterDisplay",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      (v210/*:: as any*/)
    ]
  },
  {
    "condition": "isPdpSellerModuleTestVariant",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "condition": "afterDisplay",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "gdprDisplayInfo",
            "kind": "LinkedField",
            "name": "gdprDisplayInfo",
            "plural": false,
            "selections": [
              (v211/*:: as any*/),
              (v212/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "detectFeedbackLanguage",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "detectFeedbackLanguage"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
          }
        ]
      },
      (v213/*:: as any*/)
    ]
  },
  (v214/*:: as any*/)
],
v216 = [
  (v60/*:: as any*/),
  (v66/*:: as any*/)
],
v217 = [
  (v118/*:: as any*/)
],
v218 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v219 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanceled",
  "storageKey": null
},
v220 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v221 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    (v117/*:: as any*/)
  ],
  "storageKey": null
},
v222 = [
  (v68/*:: as any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
],
v223 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v224 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canShowSellerName",
  "storageKey": null
},
v225 = [
  (v223/*:: as any*/),
  {
    "condition": "isPdpSellerModuleTestVariant",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      (v198/*:: as any*/),
      (v221/*:: as any*/),
      (v224/*:: as any*/)
    ]
  },
  {
    "condition": "isTrade",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TradeFirmType",
        "kind": "LinkedField",
        "name": "tradeFirm",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmRewards",
            "kind": "LinkedField",
            "name": "rewards",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ParentProgram",
                "kind": "LinkedField",
                "name": "currentProgram",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LoyaltyProgram",
                    "kind": "LinkedField",
                    "name": "programInfo",
                    "plural": false,
                    "selections": (v67/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ENHANCED_BUYER_PROTECTION"
                      }
                    ],
                    "concreteType": "LoyaltyProgram",
                    "kind": "LinkedField",
                    "name": "childPrograms",
                    "plural": true,
                    "selections": (v67/*:: as any*/),
                    "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v66/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  }
],
v226 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v14/*:: as any*/),
      (v15/*:: as any*/),
      (v16/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/),
      (v19/*:: as any*/),
      (v20/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PdpHeadBuilder_viewer",
            "selections": [
              (v21/*:: as any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespMarketplaceLayoutPrimary_viewer"
          },
          {
            "alias": null,
            "args": (v22/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "PdpHeadBuilder_item",
                    "selections": [
                      (v23/*:: as any*/),
                      (v26/*:: as any*/),
                      (v27/*:: as any*/),
                      (v28/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "pdpMetaItems",
                        "kind": "LinkedField",
                        "name": "pdpMeta",
                        "plural": false,
                        "selections": [
                          (v29/*:: as any*/),
                          (v30/*:: as any*/),
                          (v31/*:: as any*/),
                          (v32/*:: as any*/),
                          (v33/*:: as any*/),
                          (v34/*:: as any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "getLanguageAnnotations_pdpMetaItems",
                            "selections": [
                              (v35/*:: as any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v39/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "sortedPhotos",
                        "plural": true,
                        "selections": [
                          (v40/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v41/*:: as any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": [
                      {
                        "kind": "RootArgument",
                        "name": "forcedCurrency"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "priceBookName"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "userCountryCode"
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "handlePdpStatuses_item",
                        "selections": [
                          (v30/*:: as any*/),
                          (v42/*:: as any*/),
                          (v28/*:: as any*/),
                          (v43/*:: as any*/),
                          (v44/*:: as any*/),
                          (v45/*:: as any*/),
                          (v46/*:: as any*/),
                          (v47/*:: as any*/),
                          (v48/*:: as any*/),
                          (v49/*:: as any*/),
                          (v50/*:: as any*/),
                          (v51/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              (v52/*:: as any*/),
                              (v53/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v54/*:: as any*/),
                            "concreteType": "MetricDetailType",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": true,
                            "selections": (v56/*:: as any*/),
                            "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                          },
                          (v57/*:: as any*/),
                          (v58/*:: as any*/),
                          (v59/*:: as any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "findPdpItemReadError_itemRead",
                "selections": [
                  (v60/*:: as any*/),
                  (v61/*:: as any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v19/*:: as any*/),
      (v18/*:: as any*/),
      (v20/*:: as any*/),
      (v11/*:: as any*/),
      (v4/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v15/*:: as any*/),
      (v7/*:: as any*/),
      (v17/*:: as any*/),
      (v0/*:: as any*/),
      (v14/*:: as any*/),
      (v1/*:: as any*/),
      (v6/*:: as any*/),
      (v10/*:: as any*/),
      (v16/*:: as any*/),
      (v5/*:: as any*/),
      (v9/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v21/*:: as any*/),
          {
            "alias": null,
            "args": (v64/*:: as any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v67/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "vimeoItemsVideoHLSPlayerFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "vimeoItemsVideoHLSPlayer"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
          },
          {
            "alias": null,
            "args": (v22/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v60/*:: as any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isItemReadType"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "itemIsOnHold",
                    "args": (v69/*:: as any*/),
                    "kind": "ScalarField",
                    "name": "isOnHold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v66/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerTimeAway",
                        "kind": "LinkedField",
                        "name": "activeTimeAway",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v53/*:: as any*/),
                      (v42/*:: as any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v70/*:: as any*/),
                          (v76/*:: as any*/),
                          (v77/*:: as any*/),
                          (v78/*:: as any*/),
                          (v79/*:: as any*/),
                          (v80/*:: as any*/),
                          (v84/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v85/*:: as any*/),
                            "concreteType": "BuyerOrderReviewType",
                            "kind": "LinkedField",
                            "name": "buyerOrderReview",
                            "plural": false,
                            "selections": [
                              (v86/*:: as any*/),
                              (v30/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "image",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pdpUrl",
                                "storageKey": null
                              },
                              (v60/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "isPdpSellerModuleTestVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                                "kind": "LinkedField",
                                "name": "orderFeedbackPdp",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AggregatedOrderFeedbackType",
                                        "kind": "LinkedField",
                                        "name": "aggregatedFeedback",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AggregatedOrderFeedbackQuestionType",
                                            "kind": "LinkedField",
                                            "name": "overallExperience",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "AggregatedOrderFeedbackStarType",
                                                "kind": "LinkedField",
                                                "name": "starBreakdown",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "stars",
                                                    "storageKey": null
                                                  },
                                                  (v87/*:: as any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "totalReviews",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v88/*:: as any*/),
                    "concreteType": "ItemDisplayInfo",
                    "kind": "LinkedField",
                    "name": "displayInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "kind": "LinkedField",
                        "name": "ctas",
                        "plural": false,
                        "selections": [
                          (v89/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showSale",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showNet",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showUnavailable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "kind": "LinkedField",
                            "name": "ctas",
                            "plural": false,
                            "selections": [
                              (v90/*:: as any*/),
                              (v91/*:: as any*/),
                              (v92/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "skus",
                    "plural": true,
                    "selections": [
                      (v42/*:: as any*/),
                      (v66/*:: as any*/),
                      (v94/*:: as any*/),
                      (v95/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v30/*:: as any*/),
                  (v96/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemClassification",
                    "kind": "LinkedField",
                    "name": "classification",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creationDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCategory",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "precedence",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v37/*:: as any*/),
                              (v51/*:: as any*/),
                              (v66/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attribution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v37/*:: as any*/),
                          (v97/*:: as any*/),
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v66/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v98/*:: as any*/),
                      (v73/*:: as any*/),
                      (v99/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPublishedPrivate",
                    "storageKey": null
                  },
                  (v27/*:: as any*/),
                  (v100/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      (v101/*:: as any*/),
                      (v66/*:: as any*/),
                      (v39/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*:: as any*/),
                  (v94/*:: as any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "convertToVimeoFormat",
                        "value": false
                      }
                    ],
                    "concreteType": "VideoVimeo",
                    "kind": "LinkedField",
                    "name": "videoVimeo",
                    "plural": false,
                    "selections": [
                      (v72/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vimeoId",
                        "storageKey": null
                      },
                      (v60/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          (v102/*:: as any*/),
                          (v103/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w100h75"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                      },
                      {
                        "alias": "galleryThumbnail",
                        "args": [
                          (v102/*:: as any*/),
                          (v103/*:: as any*/),
                          (v104/*:: as any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w1280h720\")"
                      },
                      {
                        "alias": "posterThumbnail",
                        "args": [
                          (v102/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "pad",
                            "value": true
                          },
                          (v104/*:: as any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:true,size:\"w1280h720\")"
                      },
                      (v105/*:: as any*/),
                      (v106/*:: as any*/),
                      {
                        "alias": null,
                        "args": (v107/*:: as any*/),
                        "concreteType": "VideoVimeoFile",
                        "kind": "LinkedField",
                        "name": "fileByVideoSize",
                        "plural": false,
                        "selections": (v108/*:: as any*/),
                        "storageKey": "fileByVideoSize(size:\"adaptive\")"
                      },
                      {
                        "alias": "thumbThumbnail",
                        "args": [
                          (v102/*:: as any*/),
                          (v103/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "w200h150"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w200h150\")"
                      },
                      {
                        "alias": "videoUrl",
                        "args": (v107/*:: as any*/),
                        "concreteType": "VideoVimeoFile",
                        "kind": "LinkedField",
                        "name": "fileByVideoSize",
                        "plural": false,
                        "selections": (v108/*:: as any*/),
                        "storageKey": "fileByVideoSize(size:\"adaptive\")"
                      }
                    ],
                    "storageKey": "videoVimeo(convertToVimeoFormat:false)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VideoV2",
                    "kind": "LinkedField",
                    "name": "videoMux",
                    "plural": false,
                    "selections": [
                      (v72/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "playbackId",
                        "storageKey": null
                      },
                      (v60/*:: as any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 75
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 100
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:75,width:100)"
                      },
                      {
                        "alias": "galleryThumbnail",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "fitMode",
                            "value": "smartcrop"
                          },
                          (v109/*:: as any*/),
                          (v110/*:: as any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(fitMode:\"smartcrop\",height:720,width:1280)"
                      },
                      {
                        "alias": "posterThumbnail",
                        "args": [
                          (v109/*:: as any*/),
                          (v110/*:: as any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:720,width:1280)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "assetId",
                        "storageKey": null
                      },
                      (v105/*:: as any*/),
                      (v106/*:: as any*/),
                      {
                        "alias": "thumbThumbnail",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 150
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 200
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:150,width:200)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMultiSku",
                    "storageKey": null
                  },
                  (v31/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemMeasurement",
                    "kind": "LinkedField",
                    "name": "measurement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "IN"
                          }
                        ],
                        "concreteType": "ItemConvertedMeasurementsType",
                        "kind": "LinkedField",
                        "name": "convertedMeasurements",
                        "plural": false,
                        "selections": [
                          (v105/*:: as any*/)
                        ],
                        "storageKey": "convertedMeasurements(unit:\"IN\")"
                      },
                      {
                        "alias": "widthDimensions",
                        "args": [
                          (v111/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "width"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v112/*:: as any*/),
                        "storageKey": "display(addLabel:false,fields:[\"width\"])"
                      },
                      {
                        "alias": "heightDimensions",
                        "args": [
                          (v111/*:: as any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "height"
                            ]
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "kind": "LinkedField",
                        "name": "display",
                        "plural": true,
                        "selections": (v112/*:: as any*/),
                        "storageKey": "display(addLabel:false,fields:[\"height\"])"
                      }
                    ],
                    "storageKey": null
                  },
                  (v113/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "sortedPhotos",
                    "plural": true,
                    "selections": [
                      (v101/*:: as any*/),
                      (v40/*:: as any*/),
                      (v66/*:: as any*/),
                      (v60/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "kind": "LinkedField",
                        "name": "imageSkuXrefs",
                        "plural": true,
                        "selections": [
                          (v95/*:: as any*/),
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "alt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "kind": "LinkedField",
                    "name": "attributes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "framingStatus",
                        "plural": true,
                        "selections": (v56/*:: as any*/),
                        "storageKey": null
                      },
                      (v66/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Hold",
                    "kind": "LinkedField",
                    "name": "activeHold",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayTimeToExpire",
                        "storageKey": null
                      },
                      (v66/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v123/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "viewInRoomPhotos",
                    "kind": "LinkedField",
                    "name": "viewInRoomPhotos",
                    "plural": true,
                    "selections": [
                      (v60/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "src",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "credits",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosCenterPosition",
                        "kind": "LinkedField",
                        "name": "centerPosition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "top",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "left",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosComparatorWidth",
                        "kind": "LinkedField",
                        "name": "comparatorWidth",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pixel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inches",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v58/*:: as any*/),
                  (v49/*:: as any*/),
                  (v44/*:: as any*/),
                  (v45/*:: as any*/),
                  {
                    "alias": "categoryL2",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "level",
                        "value": 2
                      }
                    ],
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "getCategoriesByLevel",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      (v66/*:: as any*/)
                    ],
                    "storageKey": "getCategoriesByLevel(level:2)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contemporaryTrackingString",
                    "storageKey": null
                  },
                  (v51/*:: as any*/),
                  (v124/*:: as any*/),
                  (v125/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isComplete",
                    "storageKey": null
                  },
                  (v43/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  (v23/*:: as any*/),
                  (v26/*:: as any*/),
                  (v28/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "pdpMetaItems",
                    "kind": "LinkedField",
                    "name": "pdpMeta",
                    "plural": false,
                    "selections": [
                      (v29/*:: as any*/),
                      (v30/*:: as any*/),
                      (v31/*:: as any*/),
                      (v32/*:: as any*/),
                      (v33/*:: as any*/),
                      (v34/*:: as any*/),
                      (v35/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*:: as any*/),
                  {
                    "condition": "afterDisplayOrBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v126/*:: as any*/),
                          (v127/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SkuQuantityOption",
                            "kind": "LinkedField",
                            "name": "quantitySelectOptions",
                            "plural": true,
                            "selections": [
                              (v128/*:: as any*/),
                              (v55/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "setSize",
                            "storageKey": null
                          },
                          {
                            "condition": "isMultiSku",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v123/*:: as any*/)
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v72/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v129/*:: as any*/),
                      (v57/*:: as any*/),
                      {
                        "alias": null,
                        "args": (v69/*:: as any*/),
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "lastActiveTransaction",
                        "plural": false,
                        "selections": [
                          (v42/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasCompletedCheckout",
                            "storageKey": null
                          },
                          (v66/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "checkoutDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPricing",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "totalAmount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConvertedAmounts",
                                "kind": "LinkedField",
                                "name": "convertedAmounts",
                                "plural": false,
                                "selections": [
                                  (v130/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "GBP",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "EUR",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "CAD",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "AUD",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "CHF",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "MXN",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "NOK",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "SEK",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "DKK",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v50/*:: as any*/),
                      (v131/*:: as any*/),
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "displayPriceDefault",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "DEFAULT"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v132/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"DEFAULT\")"
                              },
                              {
                                "alias": "displayPriceAU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "AU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v132/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"AU\")"
                              },
                              {
                                "alias": "displayPriceEU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "EU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v132/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"EU\")"
                              },
                              {
                                "alias": "displayPriceGB",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "GB"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v132/*:: as any*/),
                                "storageKey": "displayPrice(priceBookName:\"GB\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v139/*:: as any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v140/*:: as any*/),
                          {
                            "alias": "makeOfferVpvParams",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "excludedPurchaseStatuses",
                                "value": [
                                  "RET",
                                  "CUST"
                                ]
                              },
                              (v63/*:: as any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "pdpTrackingVpvParams",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "isMultiSku",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v88/*:: as any*/),
                                "concreteType": "SkuDisplayInfo",
                                "kind": "LinkedField",
                                "name": "displayInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CTADisplay",
                                    "kind": "LinkedField",
                                    "name": "ctas",
                                    "plural": false,
                                    "selections": [
                                      (v90/*:: as any*/),
                                      (v91/*:: as any*/),
                                      (v92/*:: as any*/),
                                      (v89/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isPdpItemModuleTestVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": "storyTelling",
                        "args": (v141/*:: as any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v142/*:: as any*/),
                              (v143/*:: as any*/),
                              (v144/*:: as any*/),
                              (v146/*:: as any*/),
                              (v147/*:: as any*/),
                              (v148/*:: as any*/),
                              (v149/*:: as any*/),
                              (v150/*:: as any*/),
                              (v151/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      (v152/*:: as any*/),
                      (v158/*:: as any*/),
                      (v46/*:: as any*/),
                      (v159/*:: as any*/),
                      (v167/*:: as any*/),
                      (v168/*:: as any*/),
                      (v169/*:: as any*/),
                      (v174/*:: as any*/),
                      (v176/*:: as any*/),
                      (v177/*:: as any*/),
                      (v129/*:: as any*/),
                      (v179/*:: as any*/),
                      (v183/*:: as any*/),
                      (v185/*:: as any*/),
                      (v186/*:: as any*/),
                      (v191/*:: as any*/),
                      (v204/*:: as any*/)
                    ]
                  },
                  {
                    "condition": "isPdpItemModuleTestVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "storyTelling",
                        "args": (v141/*:: as any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v143/*:: as any*/),
                              (v142/*:: as any*/),
                              (v144/*:: as any*/),
                              (v147/*:: as any*/),
                              (v146/*:: as any*/),
                              (v148/*:: as any*/),
                              (v149/*:: as any*/),
                              (v150/*:: as any*/),
                              (v151/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      (v152/*:: as any*/),
                      (v158/*:: as any*/),
                      (v46/*:: as any*/),
                      (v159/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PdpDetail",
                        "kind": "LinkedField",
                        "name": "pdpDetailsDisplay",
                        "plural": true,
                        "selections": [
                          (v160/*:: as any*/),
                          (v161/*:: as any*/),
                          (v162/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "detailValues",
                            "plural": true,
                            "selections": [
                              (v60/*:: as any*/),
                              (v97/*:: as any*/),
                              (v163/*:: as any*/),
                              (v160/*:: as any*/),
                              (v51/*:: as any*/),
                              (v164/*:: as any*/),
                              (v95/*:: as any*/),
                              (v165/*:: as any*/),
                              (v166/*:: as any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "measurementDisplayName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "metricValue",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inchesValue",
                                    "storageKey": null
                                  }
                                ],
                                "type": "PdpDetailDimensionsValue",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v168/*:: as any*/),
                      (v169/*:: as any*/),
                      (v174/*:: as any*/),
                      (v176/*:: as any*/),
                      (v177/*:: as any*/),
                      (v129/*:: as any*/),
                      (v179/*:: as any*/),
                      (v183/*:: as any*/),
                      (v185/*:: as any*/),
                      (v186/*:: as any*/),
                      (v191/*:: as any*/),
                      (v204/*:: as any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v179/*:: as any*/),
                      (v181/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v157/*:: as any*/),
                          (v155/*:: as any*/),
                          (v156/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v85/*:: as any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReturnPolicyCopy",
                            "kind": "LinkedField",
                            "name": "buyerCopy",
                            "plural": false,
                            "selections": [
                              (v173/*:: as any*/),
                              (v171/*:: as any*/),
                              (v172/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v159/*:: as any*/),
                      (v152/*:: as any*/),
                      (v167/*:: as any*/),
                      (v168/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isJewelrySeller",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelry",
                        "storageKey": null
                      },
                      (v129/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadTimeDisplay",
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v182/*:: as any*/),
                          (v202/*:: as any*/),
                          (v203/*:: as any*/)
                        ]
                      },
                      (v186/*:: as any*/)
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v131/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "kind": "LinkedField",
                        "name": "variableAttributes",
                        "plural": true,
                        "selections": [
                          (v42/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "kind": "LinkedField",
                            "name": "variableAttributeData",
                            "plural": false,
                            "selections": [
                              (v97/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "kind": "LinkedField",
                                "name": "primaryAttribute",
                                "plural": false,
                                "selections": (v187/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "kind": "LinkedField",
                                "name": "swatchSort",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortOrder",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "kind": "LinkedField",
                                    "name": "swatch",
                                    "plural": false,
                                    "selections": [
                                      (v42/*:: as any*/),
                                      (v97/*:: as any*/),
                                      (v31/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "ringSize",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SwatchAttributeByNameProperties",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "us",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "mm",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "material",
                                        "plural": false,
                                        "selections": (v38/*:: as any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v37/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentName",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v66/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "buyerSideSkus",
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v42/*:: as any*/),
                          (v199/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidePrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "retailPrice",
                                "plural": false,
                                "selections": (v205/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "netPrice",
                                "plural": false,
                                "selections": (v205/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "salePrice",
                                "plural": false,
                                "selections": (v205/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v126/*:: as any*/),
                          (v127/*:: as any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "PDP"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "leadTime",
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "kind": "LinkedField",
                            "name": "variableAttributeSelections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "kind": "LinkedField",
                                "name": "variableAttribute",
                                "plural": false,
                                "selections": (v153/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "kind": "LinkedField",
                                "name": "swatch",
                                "plural": false,
                                "selections": (v153/*:: as any*/),
                                "storageKey": null
                              },
                              (v66/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPdpSimilarSoldItemsModuleVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v139/*:: as any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v46/*:: as any*/),
                      (v47/*:: as any*/),
                      (v48/*:: as any*/),
                      (v50/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v52/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v54/*:: as any*/),
                        "concreteType": "MetricDetailType",
                        "kind": "LinkedField",
                        "name": "metrics",
                        "plural": true,
                        "selections": [
                          (v55/*:: as any*/),
                          (v66/*:: as any*/)
                        ],
                        "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                      },
                      (v57/*:: as any*/),
                      (v59/*:: as any*/)
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v192/*:: as any*/),
              (v61/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "similarLandingItems",
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "similarItemsCount"
              },
              (v115/*:: as any*/),
              (v62/*:: as any*/),
              {
                "kind": "Literal",
                "name": "useML",
                "value": true
              }
            ],
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v42/*:: as any*/),
                      (v125/*:: as any*/),
                      (v124/*:: as any*/),
                      (v51/*:: as any*/),
                      (v30/*:: as any*/),
                      (v113/*:: as any*/),
                      (v27/*:: as any*/),
                      (v96/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCreator",
                        "kind": "LinkedField",
                        "name": "creators",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Creator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v187/*:: as any*/),
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 1
                          }
                        ],
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v40/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": true,
                            "selections": [
                              (v36/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": "photos(limit:1)"
                      },
                      (v66/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v66/*:: as any*/),
          {
            "condition": "isPdpItemModuleTestVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": (v215/*:: as any*/)
          },
          {
            "condition": "isPdpItemModuleTestVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v215/*:: as any*/)
          },
          {
            "condition": "fetchPdp",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "isPdpStfEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "enablePdpStf"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"enablePdpStf\")"
              },
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "fetchPdp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "gdprDisplayInfo",
                        "kind": "LinkedField",
                        "name": "gdprDisplayInfo",
                        "plural": false,
                        "selections": [
                          (v211/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "gdprDisplayInfo",
                            "kind": "LinkedField",
                            "name": "gdprDisplayInfo",
                            "plural": false,
                            "selections": [
                              (v212/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v22/*:: as any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v140/*:: as any*/),
                      {
                        "alias": null,
                        "args": (v85/*:: as any*/),
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "activePromotion",
                        "plural": false,
                        "selections": (v67/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerTiers",
                            "kind": "LinkedField",
                            "name": "sellerTiers",
                            "plural": false,
                            "selections": [
                              (v81/*:: as any*/),
                              (v82/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dealerSince",
                            "storageKey": null
                          },
                          (v196/*:: as any*/),
                          (v80/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": (v216/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v133/*:: as any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v217/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v217/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v217/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AbTestConfigV2UserVariant",
                            "kind": "LinkedField",
                            "name": "seoAbTestV2List",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "variant",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AbTestConfigV2",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "testName",
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v62/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 10
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "personalizationId"
                  }
                ],
                "concreteType": "PersonalizedItems",
                "kind": "LinkedField",
                "name": "personalizedItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "associationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPersonalizedItem",
                    "storageKey": null
                  },
                  (v66/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v64/*:: as any*/),
                "concreteType": "BuyerUrgencyInfo",
                "kind": "LinkedField",
                "name": "buyerUrgencyInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalConversations",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemUrgencyInfoType",
                    "kind": "LinkedField",
                    "name": "itemUrgency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urgencyInfoType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      (v87/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUrgencyInfo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v62/*:: as any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v210/*:: as any*/),
              (v213/*:: as any*/),
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v85/*:: as any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v216/*:: as any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isInteractivePdpChat",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v22/*:: as any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "itemRead",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              (v76/*:: as any*/),
                              (v77/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerTiers",
                                "kind": "LinkedField",
                                "name": "sellerTiers",
                                "plural": false,
                                "selections": [
                                  (v83/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v200/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "shippingAddress",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayCityStateCountry",
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PresenceResults",
                                "kind": "LinkedField",
                                "name": "presence",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "recentOnlineDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showOnlineStatus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v152/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnavailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuotes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isComplimentary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCalculated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "kind": "LinkedField",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      (v130/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "kind": "LinkedField",
                                "name": "serviceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "kind": "LinkedField",
                                    "name": "region",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "regionName",
                                        "storageKey": null
                                      },
                                      (v66/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v66/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "buyerChatDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v201/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Item",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "presenceFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "presence"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"presence\")"
                  },
                  {
                    "alias": "readReceiptsFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "readReceipts"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"readReceipts\")"
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v68/*:: as any*/),
                          (v62/*:: as any*/)
                        ],
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "buyerItemConversation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasMessageFromSeller",
                            "storageKey": null
                          },
                          (v42/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasUnreadMessageForMember",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "originalBuyer",
                            "plural": false,
                            "selections": (v153/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSkuType",
                                "kind": "LinkedField",
                                "name": "sku",
                                "plural": false,
                                "selections": (v153/*:: as any*/),
                                "storageKey": null
                              },
                              (v66/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedback",
                                "kind": "LinkedField",
                                "name": "orderFeedback",
                                "plural": false,
                                "selections": [
                                  (v72/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "token",
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "sellerMember",
                            "plural": false,
                            "selections": [
                              (v42/*:: as any*/),
                              (v66/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastConversationReadDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Message",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userType",
                                    "value": "BUYER"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "translatedTextBody",
                                "storageKey": "translatedTextBody(userType:\"BUYER\")"
                              },
                              (v66/*:: as any*/),
                              (v42/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textBody",
                                "storageKey": null
                              },
                              (v218/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fromUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shipmentTrackingNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v187/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": (v216/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedNetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadePrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeNetPriceOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionAutomatedPrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionSpecialShippingRequests",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldPlaced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldReleased",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCallInitiated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomizationOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomization",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBundledOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferHoldSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionInternalAdminJoined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMarkedShipped",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclinedApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionDealerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBuyerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v42/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isApoFromCart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expirationDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isExpired",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSubmitted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRevisedByDealer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCountered",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "amountPerItem",
                                    "plural": false,
                                    "selections": (v135/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "kind": "LinkedField",
                                "name": "transaction",
                                "plural": false,
                                "selections": [
                                  (v219/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Offer",
                                    "kind": "LinkedField",
                                    "name": "mostRecentOffer",
                                    "plural": false,
                                    "selections": (v153/*:: as any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TransactionSummaryObject",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "offerDiscountPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": (v153/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v85/*:: as any*/),
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v42/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              (v197/*:: as any*/),
                              (v220/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v221/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Summary",
                            "kind": "LinkedField",
                            "name": "conversationSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unread",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v222/*:: as any*/),
                        "concreteType": "ConversationsSolrConnection",
                        "kind": "LinkedField",
                        "name": "conversationsSolr",
                        "plural": false,
                        "selections": [
                          (v208/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationsSolrEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Conversation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v42/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessage",
                                    "storageKey": null
                                  },
                                  (v218/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inboxImage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numberOfMessages",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v30/*:: as any*/),
                                      (v42/*:: as any*/),
                                      (v66/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ItemSkuType",
                                    "kind": "LinkedField",
                                    "name": "sku",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "skuPhotoWebPath",
                                        "args": (v93/*:: as any*/),
                                        "kind": "ScalarField",
                                        "name": "firstPhotoWebPath",
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      (v66/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessageReceivedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "hasReplied",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLatestMessageSender",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMember",
                                    "kind": "LinkedField",
                                    "name": "originalBuyer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasUnreadTag",
                                        "storageKey": null
                                      },
                                      (v66/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/),
                                  (v60/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v222/*:: as any*/),
                        "filters": [
                          "page",
                          "buyerId"
                        ],
                        "handle": "connection",
                        "key": "BuyerChatVariant_conversations",
                        "kind": "LinkedHandle",
                        "name": "conversationsSolr"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isEstimateSimilarSoldVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v214/*:: as any*/)
                ]
              }
            ]
          },
          {
            "condition": "afterDisplayOrBtSsr",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "addToCartNotificationEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "AddToCartNotification"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"AddToCartNotification\")"
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v85/*:: as any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v220/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v60/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      (v189/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*:: as any*/),
                  (v66/*:: as any*/),
                  {
                    "condition": "isPdpItemModuleTestVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": (v225/*:: as any*/)
                  },
                  {
                    "condition": "isPdpItemModuleTestVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v225/*:: as any*/)
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v226/*:: as any*/),
                          (v65/*:: as any*/),
                          (v66/*:: as any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v85/*:: as any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v65/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v66/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v226/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v85/*:: as any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v223/*:: as any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v223/*:: as any*/),
                      (v224/*:: as any*/)
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isMultiSku",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds"
                  }
                ],
                "concreteType": "TransactionConnection",
                "kind": "LinkedField",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v95/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPrivateOffer",
                            "storageKey": null
                          },
                          (v219/*:: as any*/),
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/579.0.0-2026-09-30T18:54:05.208Z/pdpRespMarketplacePrimaryRootQuery",
    "metadata": {},
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f0754a47bede50dc4d62e7b4504d4a38";

export default node;
